import {
    getPlayerAlerts,
    getPlayerById,
    getPlayerEvents
} from './player.backend';
import { put } from 'redux-saga/effects';
import {
    fetchPlayerAlertsFail,
    fetchPlayerAlertsSuccess,
    fetchPlayerDetailsFail,
    fetchPlayerDetailsSuccess,
    fetchPlayerEventsFail,
    fetchPlayerEventsSuccess
} from './actions';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { pagingParams } from '../../../../../../shared/helpers/url-params.helper';

export function* fetchPlayerDetailsSaga(action) {
    try {
        const response = yield getPlayerById(action.payload);
        yield put(fetchPlayerDetailsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchPlayerDetailsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* fetchPlayerEventsSaga(action) {
    const {
        playerId,
        pagination,
        sort,
        jurisdictionCode,
        brandId,
        eventType
    } = action.payload;

    // todo: Add debouncing
    try {
        const response = yield getPlayerEvents(playerId, {
            ...pagingParams(pagination),
            ...sort,
            jurisdiction: jurisdictionCode,
            brandId,
            eventType
        });
        yield put(fetchPlayerEventsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchPlayerEventsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* fetchPlayerAlertsSaga(action) {
    const {
        playerId,
        jurisdictionCode,
        brandId,
        pagination,
        sort,
        ruleType,
        alertLevel,
        dismissed
    } = action.payload;

    try {
        const response = yield getPlayerAlerts({
            playerId,
            ...pagingParams(pagination),
            jurisdiction: jurisdictionCode,
            brandId,
            ...sort,
            ruleType,
            alertLevel,
            dismissed
        });
        yield put(fetchPlayerAlertsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchPlayerAlertsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
